import { splitPersonName } from '../../lib/utils/personNameParts';

interface PersonNameProps {
  name: string | null | undefined;
  /** Classi del contenitore (testo, colore, flex-1...). Non passare `truncate`: il taglio lo fa il componente. */
  className?: string;
  /** Tooltip; di base il nome intero. */
  title?: string;
}

/**
 * Nome di persona che, se non ci sta, si accorcia dall'inizio e tiene visibile la coda:
 * "OPERATORE AXORA GR… OP15 ANNA" invece di "OPERATORE AXORA..." per tutti.
 * Solo CSS: la testa ha `truncate` e si restringe, la coda (ultime 2 parole) non si restringe.
 * Se il nome ci sta appare identico al testo semplice. Con 2 parole o meno si comporta
 * come un normale `truncate`.
 */
export function PersonName({ name, className = '', title }: PersonNameProps) {
  const full = (name ?? '').trim();
  const { head, tail } = splitPersonName(full);
  if (!head) {
    return <span className={`block min-w-0 truncate ${className}`} title={title ?? full}>{full}</span>;
  }
  return (
    <span className={`flex min-w-0 overflow-hidden ${className}`} title={title ?? full}>
      <span className="min-w-0 truncate">{head}</span>
      {/* spazio non separabile in testa alla coda: in flex lo spazio tra due span sparirebbe.
          max-w-full + truncate: se nemmeno la coda ci sta, si taglia lei coi puntini invece di sparire a meta' */}
      <span className="max-w-full shrink-0 truncate">{` ${tail}`}</span>
    </span>
  );
}

export default PersonName;
